import { useContext } from 'react';
import { BrandConfigurationContext } from './provider';
export const useBrandConfiguration = () => {
    const value = useContext(BrandConfigurationContext);
    if (value === null) {
        throw new Error('A brand configuration must be provided');
    }
    return value;
};
export const useShortBrand = () => useBrandConfiguration().shortBrand;
